import store from '@/store';
import Vue from 'vue';
import VueRouter from 'vue-router';

import AppMedicalLayout from '@/layouts/AppMedicalLayout.vue';

Vue.use(VueRouter);

const sendToScheduleDay = (to, from, next) => {
  const storage = store.getters['users/getUserFromStorage'];
  if (!storage) next({ name: 'login' });
  else if (storage.occupation == 'Analista de Risco') next({ name: 'login' });
  else if (to.name == 'dashboard' && storage.serviceType == 'Eletivo') next({ name: 'schedule-day' });
  else if (to.name == 'schedule-day' && storage.serviceType == 'Pa') next({ name: 'dashboard' });
  else next();
};

const routes = [
  {
    path: '/',
    redirect: 'login',
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
  },
  {
    path: '/recover-password',
    name: 'recover-password',
    component: () => import('@/views/RecoverPassword.vue'),
  },
  {
    path: '/app',
    component: AppMedicalLayout,
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/medical/Dashboard.vue'),
        beforeEnter: sendToScheduleDay,
      },
      {
        path: 'schedule-day',
        name: 'schedule-day',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/medical/ScheduleViewDay.vue'),
        beforeEnter: sendToScheduleDay,
      },
      {
        path: 'overbook-queue',
        name: 'overbook-queue',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/medical/OverbookQueue.vue'),
      },
      {
        path: 'meet/:meetCode',
        name: 'meet',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/medical/SortingMeet.vue'),
      },
      {
        path: 'search',
        name: 'search',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/medical/SearchView.vue'),
        beforeEnter: sendToScheduleDay,
      },
      {
        path: 'patient-details/:patientId/:partner',
        name: 'patient-details',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/medical/PatientDetails.vue'),
        beforeEnter: sendToScheduleDay,
      },
      {
        path: 'patients-list',
        name: 'patients-list',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/medical/PatientList.vue'),
        beforeEnter: sendToScheduleDay,
      },
      {
        path: 'schedule-report',
        name: 'schedule-report',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/medical/SchedulesReport.vue'),
        beforeEnter: sendToScheduleDay,
      },
    ],
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
});

router.beforeEach((to, _, next) => {
  return next();
});

export default router;
